import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import "./PropertyDetail.css";
import { IoLocationOutline } from "react-icons/io5";
import { LuBedSingle } from "react-icons/lu";
import { CiRuler } from "react-icons/ci";
import {
  MdOutlineMail,
  MdPriceChange,
  MdOutlineCategory,
} from "react-icons/md";
import { BiBath, BiCalendar, BiUser } from "react-icons/bi";
import { FiPhone } from "react-icons/fi";
import { FaRegHandshake } from "react-icons/fa";

const PropertyDetail = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(0);

  useEffect(() => {
    fetchProperty();
    setSelectedImage(0);
  }, [id]);

  const fetchProperty = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `/api/properties/${id}`
      );
      setProperty(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching property:", error);
      setLoading(false);
      setProperty(null);
    }
  };

  if (loading) {
    return (
      <div className="property-detail-page loading-state">
        {" "}
        <div className="loading">
          <div className="spinner"></div>{" "}
        </div>{" "}
      </div>
    );
  }

  if (!property) {
    return (
      <div className="property-detail-page">
        {" "}
        <div className="container">
          {" "}
          <div className="empty-state">
            <h3>العقار غير موجود أو حدث خطأ في التحميل</h3>{" "}
            <Link to="/properties" className="btn btn-primary">
              العودة للعقارات
            </Link>{" "}
          </div>{" "}
        </div>{" "}
      </div>
    );
  }
  const formattedDate = new Date(property.createdAt).toLocaleDateString(
    "ar-SY",
    {
      year: "numeric",
      month: "long",
      day: "numeric",
    }
  );

  return (
    <div className="property-detail-page">
      {" "}
      <div className="container">
        {" "}
        <Link to="/properties" className="back-link">
          <span className="arrow">→</span> العودة للعقارات
        </Link>{" "}
        <div className="detail-layout">
          {" "}
          <div className="sidebar">
            {/* Price & Type */}
            <div className="price-type-card">
              <div className="price-info">
                <span className="price-value-large">
                  {property.price.toLocaleString()}
                </span>
                <span className="currency"> ل.س</span>{" "}
              </div>{" "}
              <div className="type-info">
                <FaRegHandshake className="type-icon" />{" "}
                <span className={`type-badge-sidebar ${property.type}`}>
                  {property.type === "buy" ? "للبيع" : "للإيجار"}{" "}
                </span>{" "}
              </div>{" "}
            </div>
            {/* Contact Info */}{" "}
            {(property.contactName ||
              property.contactPhone ||
              property.contactEmail) && (
              <div className="contact-card-sidebar">
                <h3>للتواصل مع المعلن</h3>{" "}
                {property.contactName && (
                  <div className="contact-item-sidebar">
                    <BiUser className="contact-icon" />
                    <span>{property.contactName}</span>{" "}
                  </div>
                )}{" "}
                {property.contactPhone && (
                  <div className="contact-item-sidebar phone-item">
                    <FiPhone className="contact-icon" />{" "}
                    <a
                      href={`tel:${property.contactPhone}`}
                      className="contact-link"
                    >
                      {property.contactPhone}
                    </a>{" "}
                  </div>
                )}{" "}
                {property.contactEmail && (
                  <div className="contact-item-sidebar">
                    <MdOutlineMail className="contact-icon" />{" "}
                    <a
                      href={`mailto:${property.contactEmail}`}
                      className="contact-link"
                    >
                      {property.contactEmail}
                    </a>{" "}
                  </div>
                )}{" "}
              </div>
            )}
            {/* Date Info */}{" "}
            <div className="date-card">
              <BiCalendar className="date-icon" />{" "}
              <span className="date-label">تاريخ الإضافة:</span>{" "}
              <span className="date-value">{formattedDate}</span>{" "}
            </div>{" "}
          </div>{" "}
          <div className="main-content">
            <div className="property-header">
              <h1>{property.title}</h1>{" "}
              <p className="property-location">
                <IoLocationOutline className="icon" />
                {property.city} {property.address && `- ${property.address}`}{" "}
              </p>{" "}
            </div>
            {/* Images Section */}
            <div className="property-images">
              {property.images && property.images.length > 0 ? (
                <>
                  <div className="main-image">
                    <img
                      src={`/api${property.images[selectedImage]}`}
                      alt={property.title}
                    />{" "}
                  </div>{" "}
                  {property.images.length > 1 && (
                    <div className="image-thumbnails">
                      {property.images.map((image, index) => (
                        <img
                          key={index}
                          src={`/api${image}`}
                          alt={`صورة ${index + 1}`}
                          className={selectedImage === index ? "active" : ""}
                          onClick={() => setSelectedImage(index)}
                        />
                      ))}{" "}
                    </div>
                  )}
                </>
              ) : (
                <div className="no-image-large">
                  لا توجد صور متاحة لهذا العقار
                </div>
              )}{" "}
            </div>
            {/* Key Details Grid (Under Images) */}
            <div className="key-details-row">
              <div className="detail-item-card">
                <MdOutlineCategory className="detail-icon" />
                <p className="detail-label">النوع</p>{" "}
                <p className="detail-value">{property.category}</p>{" "}
              </div>{" "}
              {/* 1. المساحة (Area) - يظهر الكرت دائمًا */}
              <div className="detail-item-card">
                <CiRuler className="detail-icon" />
                <p className="detail-label">المساحة</p>
                <p className="detail-value">
                  {property.area !== undefined && property.area !== null
                    ? `${property.area} م²`
                    : "غير متوفر"}
                </p>{" "}
              </div>
              {/* 2. الغرف (Rooms) - يظهر الكرت دائمًا */}
              <div className="detail-item-card">
                <LuBedSingle className="detail-icon" />
                <p className="detail-label">الغرف</p>
                <p className="detail-value">
                  {property.rooms !== undefined && property.rooms !== null
                    ? property.rooms
                    : "غير متوفر"}
                </p>{" "}
              </div>
              {/* 3. الحمامات (Bathrooms) - يظهر الكرت دائمًا */}
              <div className="detail-item-card">
                <BiBath className="detail-icon" />
                <p className="detail-label">الحمامات</p>
                <p className="detail-value">
                  {property.bathrooms !== undefined &&
                  property.bathrooms !== null
                    ? property.bathrooms
                    : "غير متوفر"}
                </p>{" "}
              </div>
            </div>
            {/* Description */}{" "}
            {property.description && (
              <div className="detail-section property-description">
                <h2>الوصف التفصيلي</h2> <p>{property.description}</p>{" "}
              </div>
            )}
            {/* Features */}{" "}
            {property.features && property.features.length > 0 && (
              <div className="detail-section property-features">
                <h2>الميزات المرفقة</h2>{" "}
                <ul>
                  {property.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}{" "}
                </ul>{" "}
              </div>
            )}{" "}
          </div>{" "}
        </div>{" "}
      </div>
      <Footer />{" "}
    </div>
  );
};

export default PropertyDetail;
